import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SiteInventorySection = ({ formData, updateFormData, errors }) => {
  const handleInputChange = (field, value) => {
    updateFormData('siteInventory', { ...formData?.siteInventory, [field]: value });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
          <Icon name="MapPin" size={20} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-heading font-bold text-foreground">Site Inventory</h3>
          <p className="text-sm text-muted-foreground">Define your RV site capacity and types</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Short-term RV Sites"
          type="number"
          placeholder="0"
          description="Sites for nightly/weekly stays"
          value={formData?.siteInventory?.shortTermSites}
          onChange={(e) => handleInputChange('shortTermSites', parseInt(e?.target?.value) || 0)}
          error={errors?.shortTermSites}
          min="0"
          max="500"
          required
        />

        <Input
          label="Long-term RV Sites"
          type="number"
          placeholder="0"
          description="Sites for monthly/seasonal stays"
          value={formData?.siteInventory?.longTermSites}
          onChange={(e) => handleInputChange('longTermSites', parseInt(e?.target?.value) || 0)}
          error={errors?.longTermSites}
          min="0"
          max="500"
        />
      </div>
      <div className="mt-4 p-4 bg-muted rounded-lg">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>
            Total Sites: {(formData?.siteInventory?.shortTermSites || 0) + (formData?.siteInventory?.longTermSites || 0)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SiteInventorySection;